/**
 * Brand Page Wrapper for ISR
 *
 * This wrapper component provides the brand page content for ISR rendering.
 * It uses direct imports to avoid hydration re-renders.
 * Uses centralized useIsrPageInit to handle storeServerData.
 */

'use client';

import React from 'react';
import {DynamicPageServerSideProps} from '@/_application/core/types';
import {ProductListViewProvider} from '@/_application/modules/products/provider/product-list-view.provider';
import {useIsrPageInit} from '@/_application/pages/_isr';

// Direct imports
import BrandPageDesktop from '@/_application/pages/brand/brand.desktop.page';
import BrandPageMobile from '@/_application/pages/brand/brand.mobile.page';
import BrandSeo from '@/_application/pages/brand/components/brand-seo';

export interface BrandPageWrapperProps {
    variables?: DynamicPageServerSideProps['variables'];
    isMobile?: boolean;
    layout?: DynamicPageServerSideProps['layout'];
}

export const BrandPageWrapper: React.FC<BrandPageWrapperProps> = ({variables, isMobile, layout}) => {
    // Initialize ISR page - handles storeServerData automatically
    useIsrPageInit(variables);

    if (!variables) {
        return null;
    }

    if (isMobile) {
        return (
            <ProductListViewProvider layout={layout} variables={variables}>
                {variables.brand && <BrandSeo brand={variables.brand} />}
                <BrandPageMobile variables={variables} layout={layout} />
            </ProductListViewProvider>
        );
    }

    return (
        <ProductListViewProvider layout={layout} variables={variables}>
            {variables.brand && <BrandSeo brand={variables.brand} />}
            <BrandPageDesktop variables={variables} layout={layout} />
        </ProductListViewProvider>
    );
};

export default BrandPageWrapper;
